import { styled } from '@clickcease/cc-client-components-lib'

export const GetTagInstructionsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  marginLeft: '40px',
  paddingRight: '40px',
  overflow: 'auto',

  variants: {
    noMargin: {
      true: {
        marginLeft: '0',
        paddingRight: '0',
      },
    },
  },
})

export const LogicalBlock = styled('div', {
  marginBottom: '24px',
})

export const LineSeparator = styled('div', {
  marginBottom: '12px',
})

export const CopyKeyContainer = styled('span', {
  display: 'flex',
  '> button': {
    marginLeft: '8px',
  },
})

export const GetTagInstructionsBulletContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  ':first-child': {
    marginInlineEnd: '8px',
  },
})

export const BulletPoint = styled('span', {
  width: '6px',
  minWidth: '6px',
  height: '6px',
  minHeight: '6px',
  borderRadius: '50%',
  backgroundColor: 'black',
})

export const GetTagInstructionsText = styled('span', {
  fontSize: '$md',
  fontWeight: 300,
  color: '$mainTextColor',
})

export const CodeBlock = styled('p', {
  border: '1px dashed rgba(155, 155, 155, 1)',
  borderRadius: '12px',
  fontWeight: 300,
  fontSize: '$sm',
  background: '#F5F4F2',
  color: 'rgba(40, 36, 33, 1)',
  padding: '8px 12px',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
})

export const CodeSpan = styled('p', {
  border: '1px dashed rgba(155, 155, 155, 1)',
  borderRadius: '4px',
  fontWeight: 300,
  fontSize: '$sm',
  background: '$tableHovered',
  color: 'rgba(40, 36, 33, 1)',
  padding: '6px 12px',
  whiteSpace: 'pre-wrap',
  display: 'inline-block',
  marginInlineEnd: '10px',
})

export const EmailDeveloperContainer = styled('div', {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
})

export const EmailErrorContainer = styled('div', {
  bottom: '-55px',
  position: 'absolute',
  display: 'flex',
  alignItems: 'flex-start',
  width: '300px',
  height: '50px',
})

export const EmailError = styled('div', {
  color: '$error',
  fontWeight: '$l',
  fontSize: '$md',
})
